import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://www.fiscoconseils.com";
const DEFAULT_IMAGE = `${SITE_URL}/favicon-512.png`;

export const SEO = ({ title, description, path, noindex = false, type = "website", jsonLd = [], image = DEFAULT_IMAGE, scrollTop = true }) => {
  const location = useLocation();
  const canonical = `${SITE_URL}${path ?? location.pathname}`.replace(/\/$/, "") || SITE_URL;
  const canonicalUrl = canonical === SITE_URL ? `${SITE_URL}/` : canonical;

  useEffect(() => {
    if (scrollTop) window.scrollTo(0, 0);
  }, [location.pathname, scrollTop]);

  const ld = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large"} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Fiscoconseils" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ld.filter(Boolean).map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};
